import graphContainerConfig from "config/graphContainerConfig";
import areaApiConfig from "config/charts/areaApiConfig";

const chartModalApiConfig = {
  graphContainerConfig,
  areaApiConfig
};

export default chartModalApiConfig;